import {getEventId} from '@wix/wix-events-commons-statics'
import React from 'react'
import {getEventDateInformation} from '../../../../../../../commons/selectors/event'
import {useWidgetState} from '../../../../hooks/state-provider'
import {getDateMargin, isDateVisible} from '../../../../selectors/single-settings'
import {Presentation} from '../presentation'
import {DateProps} from './interfaces'

export const Date = ({event, dataHook, className}: DateProps) => {
  const text = useWidgetState(state => getEventDateInformation(state, getEventId(event))).fullDate
  const dateVisible = useWidgetState(isDateVisible)
  const marginBottom = useWidgetState(getDateMargin)

  return dateVisible ? (
    <div className={className} style={{marginBottom}}>
      <Presentation dataHook={dataHook} text={text} settingsKey="time" />
    </div>
  ) : null
}
